import { 
    SET_TRANSLATED_LIST, 
    TRANSLATED_LIST_REQUEST, 
    TRANSLATED_LIST_RECIEVE, 
    TRANSLATED_LIST_ERROR,
    SET_LANGUAGE,
    SET_DEFAULT_LANGUAGE
} from "../action_types";
import Axios from "axios";
import store from "../store";

export const setLanguage = (language) => ({
    type: SET_LANGUAGE,
    language,
});

export const setDefaultLanguage = () => ({
    type: SET_DEFAULT_LANGUAGE,
});

export const setTranslatedList = (list) => ({
    type: SET_TRANSLATED_LIST,
    list,
});

export const translatedListRequest = () => ({
    type: TRANSLATED_LIST_REQUEST,
});

export const translatedListRecieve = () => ({
    type: TRANSLATED_LIST_RECIEVE,
});

export const translatedListError = (list) => ({
    type: TRANSLATED_LIST_ERROR,
    list,
});

export const fetchTranslatedList = () => (dispatch, getState) => {
    const { language } = getState();
    const url = `https://vendorlist.consensu.org/purposes-${language}.json`;

    dispatch(translatedListRequest());

    return Axios.get(url)
        .then((response) => {
            dispatch(translatedListRecieve());
            dispatch(setTranslatedList(response.data));
        })
        .catch((err) => {
            dispatch(setDefaultLanguage());
        });
};

export const boundFetchTranslatedList = () => store.dispatch(fetchTranslatedList());
export const boundSetLanguage = (language) => store.dispatch(setLanguage(language));
export const boundSetDefaultLanguage = () => store.dispatch(setDefaultLanguage());